import _asyncToGenerator from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/es6.function.name.js";
import { hasPermission } from "../common/helpers";
import store from "../store";
export var loginGuard = function loginGuard() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(to, from, next) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return store.dispatch('auth/authenticateUser');
          case 2:
            _context.t0 = _context.sent;
            if (!_context.t0) {
              _context.next = 5;
              break;
            }
            next('dashboard');
          case 5:
            to.name.match('login') && next();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var authGuard = function authGuard() {
  for (var _len = arguments.length, permissions = new Array(_len), _key = 0; _key < _len; _key++) {
    permissions[_key] = arguments[_key];
  }
  return function (_, __, next) {
    var fn = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var isAuthenticated, currentUser;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return store.dispatch('auth/authenticateUser');
            case 2:
              isAuthenticated = _context2.sent;
              currentUser = store.getters['auth/user'];
              if (!isAuthenticated) {
                _context2.next = 8;
                break;
              }
              if (!hasPermission(currentUser, permissions)) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt("return", next());
            case 7:
              return _context2.abrupt("return", next({
                path: '/not-authorized',
                replace: true
              }));
            case 8:
              return _context2.abrupt("return", next({
                path: '/login',
                replace: true
              }));
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function fn() {
        return _ref2.apply(this, arguments);
      };
    }();
    fn();
  };
};